// extracted by mini-css-extract-plugin
module.exports = {"CardContainer":"DashboardCardContainerWithFlow_CardContainer__1DXhJ"};